import {
    tabularPropertiesCommonAdapts,
    TabularTypeDatasetAdapter
} from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { AdapterRegistry, IModel, Metamodel, SapODataDataset } from 'shell-models-lib';
import { Model } from 'app/model/backendmodel';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapODataDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                servicePath: '*',
                entityName: '*'
            }
        }
    }
})
export class SapODataDatasetAdapter extends TabularTypeDatasetAdapter<SapODataDataset, Model.DatasetResource> {
    protected model(): IModel {
        return SapODataDataset.MODEL;
    }

    protected async _toResource(dataset: SapODataDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, this.model().name, undefined, 'servicePath', 'entityName');
    }

    protected async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: SapODataDataset
    ): Promise<SapODataDataset> {
        return await this._toModelInternal(
            modelDatasetResource,
            dataset,
            this.model(),
            undefined,
            'servicePath',
            'entityName'
        );
    }
}
